import { createFileRoute } from '@tanstack/react-router'

import PublicOrgs from 'pages/PublicOrgs'

export const Route = createFileRoute('/public/orgs/')({
  component: PublicOrgs,
})
